module.exports = __webpack_public_path__ + "s15.no2.1ad1ed56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s15.no2.jpg
// module id = CUjB
// module chunks = 0